import Button from "~/components/ui/Button";

export function GetStartedSection() {
  return (
    <div className="my-10 flex flex-col items-center gap-8 px-2 py-8 md:p-8">
      <h2 className="text-4xl font-extrabold">پس منتظر چی هستی؟</h2>
      <p className="text-xs md:text-lg">
        همین حالا شروع کن و با برترین هوش مصنوعی ایران کار هاتو پیش ببر!
      </p>
      <div className="flex gap-3">
        <Button
          link="https://pay.figai.ir"
          useRefLink={true}
          utm_term="landing_get_started"
          variant="green"
        >
          تهیه اشتراک
        </Button>
        <Button link="https://webui.figai.ir/auth" variant="sky">
          ساخت حساب
        </Button>
      </div>
    </div>
  );
}
